import { JSX } from 'react'

import { SplitsLink as Link } from '~/components/Link'

const SWAP_HELP_URL = 'https://splits.org/docs/transactions/swaps'

export const PaymentSourceTooltip = (): JSX.Element => (
  <>
    Select a token to sell to cover this transfer.{' '}
    <Link path={SWAP_HELP_URL} underline target="tab">
      Learn more
    </Link>
  </>
)
